const _jsxFileName = "C:\\Users\\sz\\Code\\open-inc\\wehn-web\\src\\js\\components\\ArtikelInfoShow.tsx";import {
  Alert,
  Descriptions,
  Divider,
  Empty,
  Image,

  Spin,
  Tabs,
  Tag,
  Typography,
} from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { ArtikelInfoShowState } from "./ArtikelInfoShow.state";
import { BestandListe } from "./BestandListe";
import { BuchungenListe } from "./BuchungenListe";






export const ArtikelInfoShow = observer(function ArtikelInfoShow({
  artikelId,
  hideBackButton,
}) {
  const state = React.useMemo(
    () => new ArtikelInfoShowState(artikelId),
    [artikelId]
  );

  if (state.loading) return React.createElement(Spin, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 33}});
  if (!state.artikel) return React.createElement(Empty, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 34}});

  return (
    React.createElement('div', { style: { background: "#fff" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}
      , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        , React.createElement(Typography.Title, { level: 3, children: state.artikel.bezeichnung, __self: this, __source: {fileName: _jsxFileName, lineNumber: 39}} )
        , React.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
          , state.dispostatus.anforderung && (
            React.createElement(Alert, {
              message: "Artikel ist angefordert"  ,
              type: "info",
              style: { marginBottom: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
            )
          )

          , state.dispostatus.bestellt && (
            React.createElement(Alert, {
              message: "Artikel ist bestellt"  ,
              type: "info",
              style: { marginBottom: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
            )
          )

          , state.dispostatus.fertigung && (
            React.createElement(Alert, {
              message: "Artikel wird gefertigt"  ,
              type: "info",
              style: { marginBottom: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}
            )
          )

          , state.dispostatus.qs && (
            React.createElement(Alert, {
              message: "Artikel befindet sich in Freigabe"    ,
              type: "info",
              style: { marginBottom: "10px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}}
            )
          )
        )
        , React.createElement(Divider, { style: { marginTop: "0px" }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
          , React.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "Artikelinfo"), " "
          , state.artikel.get("frei") && React.createElement(Tag, { color: "success", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}, "Frei")
          , state.artikel.get("gesperrt") && React.createElement(Tag, { color: "error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}, "Gesperrt")
          , state.artikel.get("auslaufartikel") && (
            React.createElement(Tag, { color: "warning", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}}, "Auslaufartikel")
          )
        )
        , React.createElement(Descriptions, { bordered: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}}
          , React.createElement(Descriptions.Item, { label: "Artikelnummer", __self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
            , state.artikel.get("artikelnummer")
          )
          , React.createElement(Descriptions.Item, { label: "Techniktext", span: 2, __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
            , state.artikel.get("techniktext") ||
              "Kein technischen Angaben verfügbar"
          )
          , React.createElement(Descriptions.Item, { label: "Dispoart", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
            , state.artikel.get("dispoart") == "K" && "Kaufteil"
            , state.artikel.get("dispoart") == "E" && "Eigenfertigung"
            , state.artikel.get("dispoart") == "F" && "Fertigung ohne Lager"
            , state.artikel.get("dispoart") == "B" && "Beispielteil"
            , state.artikel.get("dispoart") == "H" && "Handlagerteil"
            , state.artikel.get("dispoart") == "L" &&
              "Leistung ohne Lieferschein"
          )
          , React.createElement(Descriptions.Item, { label: "Seriennummerpflichtig", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
            , state.artikel.get("seriennummer") ? "Ja" : "Nein"
          )
          , React.createElement(Descriptions.Item, { label: "Chargenpflichtig", __self: this, __source: {fileName: _jsxFileName, lineNumber: 101}}
            , state.artikel.get("chargenverfolgung") ? "Ja" : "Nein"
          )
          , React.createElement(Descriptions.Item, { label: "Zeichnung", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}}
            , (state.artikel.get("zeichnung") || "") +
              (state.artikel.get("zeichnungIndex") || "") || "Nicht vorhanden"
          )
        )
        , React.createElement(Divider, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}, "Lagerinfo")
        , React.createElement(Tabs, { defaultActiveKey: "1", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
          , React.createElement(Tabs.TabPane, { tab: "Bestände", key: "1", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
            , React.createElement(BestandListe, { artikelId: artikelId, __self: this, __source: {fileName: _jsxFileName, lineNumber: 112}} )
          )
          , React.createElement(Tabs.TabPane, { tab: "Buchungen", key: "3", __self: this, __source: {fileName: _jsxFileName, lineNumber: 114}}
            , React.createElement(BuchungenListe, { buchungen: state.buchungen, showLager: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}} )
          )
        )

        , React.createElement(Image, {
          width: "100%",
          height: 300,
          src: undefined, // TODO
          fallback: "data:image/png;base64,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", __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
        )
      )
    )
  );
});
